module.exports = "<p>\n  td-maturity-instruction works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// D:/Sonali/JCCBViewOnlyProject/ViewOnlyJCCBfrontend19112022/InternetBanking6.3frontend/src/app/td-maturity-instruction/td-maturity-instruction.component.html
// module id = ../../../../../src/app/td-maturity-instruction/td-maturity-instruction.component.html
// module chunks = main